import { relayStylePagination } from '@apollo/client/utilities';

export default {
  Comment: {
    fields: {
      reactions: { merge: false },
    },
  },
  DebugAskSearchResult: {
    fields: {
      searchResults: { merge: false },
    },
  },
  ExternalPostPlatform: {
    fields: {
      posts: relayStylePagination(),
    },
  },
  ExternalSearchPlatform: {
    fields: {
      installModes: { merge: false },
    },
  },
  GithubWikiImportResult: {
    fields: {
      imported: { merge: false },
    },
  },
  Group: {
    fields: {
      allUsers: { merge: false },
      children: { merge: false },
      members: { merge: false },
      membershipTopics: { merge: false },
      owners: { merge: false },
      parents: { merge: false },
      requestors: { merge: false },
    },
  },
  History: {
    fields: {
      authors: { merge: false },
    },
  },
  InsightMetrics: {
    fields: {
      metrics: { merge: false },
    },
  },
  IntegrationSettings: {
    fields: {
      enabledParents: { merge: false },
      enabledSearchSources: { merge: false },
      syncingRepos: { merge: false },
    },
  },
  Mention: {
    fields: {
      breadcrumbs: { merge: false },
      participants: { merge: false },
      tags: { merge: false },
    },
  },
  MentionContentHighlights: {
    fields: {
      highlights: { merge: false },
    },
  },
  Mutation: {
    fields: {
      applyProvision: { merge: false },
      importFiles: { merge: false },
      importGithubWikis: { merge: false },
      markNotifications: { merge: false },
      reorderTopics: { merge: false },
    },
  },
  Organization: {
    fields: {
      auditLogs: relayStylePagination(),
      customDomains: { merge: false },
      externalUsers: { merge: false },
      groups: { merge: false },
      integrations: { merge: false },
      invitations: { merge: false },
      notifications: relayStylePagination(),
      posts: { merge: false },
      provisions: { merge: false },
      readNotifications: relayStylePagination(),
      series: { merge: false },
      topics: { merge: false },
      unreadNotifications: relayStylePagination(),
      users: { merge: false },
      webhooks: { merge: false },
    },
  },
  OrganizationSettings: {
    fields: {
      allowedEmbedHosts: { merge: false },
    },
  },
  Post: {
    fields: {
      annotations: { merge: false },
      backlinks: { merge: false },
      contributors: { merge: false },
      histories: { merge: false },
      thankers: { merge: false },
      threads: { merge: false },
      topics: { merge: false },
      verificationEntries: { merge: false },
      viewers: { merge: false },
    },
  },
  PostDirectShare: {
    fields: {
      editorGroupIds: { merge: false },
      editorIds: { merge: false },
      viewerGroupIds: { merge: false },
      viewerIds: { merge: false },
    },
  },
  PostSearchResult: {
    fields: {
      ancestors: { merge: false },
    },
  },
  Provision: {
    fields: {
      favoritePosts: { merge: false },
      favoriteTopics: { merge: false },
      groups: { merge: false },
      posts: { merge: false },
      topics: { merge: false },
    },
  },
  PublicComment: {
    fields: {
      reactions: { merge: false },
    },
  },
  PublicCommentFields: {
    fields: {
      reactions: { merge: false },
    },
  },
  PublicPost: {
    fields: {
      annotations: { merge: false },
      threads: { merge: false },
      topics: { merge: false },
    },
  },
  PublicPostFields: {
    fields: {
      annotations: { merge: false },
      threads: { merge: false },
      topics: { merge: false },
    },
  },
  PublicSearchResultConnection: {
    fields: {
      ancestorIds: { merge: false },
    },
  },
  PublicSeries: {
    fields: {
      posts: { merge: false },
    },
  },
  PublicSeriesFields: {
    fields: {
      posts: { merge: false },
    },
  },
  PublicThread: {
    fields: {
      comments: { merge: false },
      reactions: { merge: false },
    },
  },
  PublicThreadFields: {
    fields: {
      comments: { merge: false },
      reactions: { merge: false },
    },
  },
  PublicTopic: {
    fields: {
      ancestors: { merge: false },
      descendants: relayStylePagination(),
      posts: { merge: false },
    },
  },
  PublicTopicFields: {
    fields: {
      ancestors: { merge: false },
    },
  },
  Query: {
    fields: {
      activities: relayStylePagination(),
      externalPostPlatforms: { merge: false },
      externalSearch: { merge: false },
      externalSearchPlatforms: { merge: false },
      externalSearchSources: { merge: false },
      gitRepos: { merge: false },
      insightLeaderboard: relayStylePagination(),
      insightTopPosts: relayStylePagination(),
      insightTopSearches: relayStylePagination(),
      mentionParents: { merge: false },
      organizations: { merge: false },
      publicSearch: relayStylePagination(),
      search: relayStylePagination(),
      unorganized: relayStylePagination(),
    },
  },
  RootPostFields: {
    fields: {
      topics: { merge: false },
    },
  },
  Series: {
    fields: {
      posts: { merge: false },
    },
  },
  SlimHistory: {
    fields: {
      authors: { merge: false },
    },
  },
  SlimHistoryFields: {
    fields: {
      authors: { merge: false },
    },
  },
  SlimPost: {
    fields: {
      contributors: { merge: false },
      topics: { merge: false },
    },
  },
  SlimPostFields: {
    fields: {
      contributors: { merge: false },
      topics: { merge: false },
    },
  },
  Subscription: {
    fields: {
      notificationsUpdated: { merge: false },
    },
  },
  Thread: {
    fields: {
      comments: { merge: false },
      reactions: { merge: false },
    },
  },
  Topic: {
    fields: {
      activities: relayStylePagination(),
      allPosts: relayStylePagination(),
      ancestors: { merge: false },
      children: { merge: false },
      contributors: { merge: false },
      descendants: relayStylePagination(),
      hierarchy: { merge: false },
      inheritedAncestors: { merge: false },
      integrationLinks: { merge: false },
      memberGroups: { merge: false },
      members: { merge: false },
      ownerGroups: { merge: false },
      owners: { merge: false },
      postCounts: { merge: false },
      posts: relayStylePagination(),
      requestors: { merge: false },
    },
  },
  TopicMembership: {
    fields: {
      memberGroupIds: { merge: false },
      memberUserIds: { merge: false },
      ownerGroupIds: { merge: false },
      ownerUserIds: { merge: false },
      requestorUserIds: { merge: false },
    },
  },
  TopicSearchResult: {
    fields: {
      ancestors: { merge: false },
    },
  },
  User: {
    fields: {
      contributedTopics: { merge: false },
      drafts: relayStylePagination(),
      favoritePosts: { merge: false },
      favoriteTopics: { merge: false },
      identities: { merge: false },
      membershipGroups: { merge: false },
      membershipTopics: { merge: false },
      onboardings: { merge: false },
      posts: relayStylePagination(),
      viewedPosts: relayStylePagination(),
    },
  },
  UserSidebarSettings: {
    fields: {
      favoriteIds: { merge: false },
      hiddenItems: { merge: false },
      myTopicIds: { merge: false },
    },
  },
  Verification: {
    fields: {
      secondaryVerifiers: { merge: false },
    },
  },
  Webhook: {
    fields: {
      events: { merge: false },
      logs: relayStylePagination(),
      topics: { merge: false },
    },
  },
};
